export default __webpack_public_path__ + "static/media/why-us.0b38b56d.png";